<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2026. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: ztn-user-avatar.vue
  - Created by: chan.ying
  - Create Date: 2026-09-02
  - Version Number: 1.0
  - Version Description: Photo avatar with username-initial fallback when no
  -   photo is uploaded (or the photo URL fails to load).
  -
  - =============================================================================
  -->

<template>
  <div
      class="ztn-user-avatar"
      :style="boxStyle"
      role="img"
      :aria-label="displayName"
  >
    <img
        v-if="src"
        v-show="showPhoto"
        :src="src"
        :alt="displayName"
        class="ztn-user-avatar__img"
        @load="showPhoto = true"
        @error="showPhoto = false"
    />
    <span v-if="!showPhoto" class="ztn-user-avatar__letter">{{ initial }}</span>
  </div>
</template>

<script>
export default {
  name: "ztn-user-avatar",
  props: {
    src: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    size: {
      type: [Number, String],
      default: 32,
    },
  },
  data() {
    return {
      showPhoto: false,
    };
  },
  computed: {
    sizePx() {
      const n = Number(this.size);
      return Number.isFinite(n) && n > 0 ? n : 32;
    },
    displayName() {
      return (this.name || "").trim() || "User";
    },
    initial() {
      const source = this.displayName;
      const first = Array.from(source)[0] || "U";
      return first.toUpperCase();
    },
    boxStyle() {
      return {
        width: this.sizePx + "px",
        height: this.sizePx + "px",
        fontSize: Math.max(12, Math.round(this.sizePx * 0.4)) + "px",
      };
    },
  },
  watch: {
    src() {
      this.showPhoto = false;
    },
  },
};
</script>

<style scoped>
.ztn-user-avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: var(--radius-full, 50%);
  background-color: var(--base-bg-primary-8) !important;
  color: var(--body-color-1);
  font-weight: 600;
  line-height: 1;
  user-select: none;
}

.ztn-user-avatar__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ztn-user-avatar__letter {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
